export const PROMO_CODE_REMOVE_STALE = 'PROMO_CODE_REMOVE_STALE';
